<script lang="ts" module>
	import Icon from "@components/common/Icon.svelte";
	import call from "@core/assets/icons/call.svg?raw";
	import copy from "@core/assets/icons/copy.svg?raw";
	import linkedinUrl from "@core/assets/icons/linkedin-framed.svg?raw";
	import send from "@core/assets/icons/send.svg?raw";
	import { Locale, type LocalizedString } from "@core/schema/Locale.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import type { ContactActionType } from "./ContactActionType.js";

	const copyLabelMap: Record<ContactActionType, LocalizedString> = {
		email: {
			[Locale.cs]: "Zkopírovat adresu do schránky",
		},
		linkedinUrl: {
			[Locale.cs]: "Zkopírovat LinkedIn odkaz",
		},
		phone: {
			[Locale.cs]: "Zkopírovat číslo do schránky",
		},
	};

	const actionLabelMap: Record<ContactActionType, LocalizedString> = {
		email: {
			[Locale.cs]: "Poslat e-mail",
		},
		linkedinUrl: {
			[Locale.cs]: "Otevřít LinkedIn profil",
		},
		phone: {
			[Locale.cs]: "Volat",
		},
	};

	const iconMap: Record<ContactActionType, string> = {
		phone: call,
		email: send,
		linkedinUrl,
	};
</script>

<script lang="ts">
	const {
		isOpen,
		actionType,
		value,
		direction,
		onclose,
	}: {
		isOpen: boolean;
		value: string | undefined;
		actionType: ContactActionType;
		onclose(this: void, reason: "copy" | "navigated"): void;
		direction: "horizontal" | "vertical";
	} = $props();

	const { tenant } = getGlobalTemplateProps();
</script>

<div class={["absolute left-0 right-0 transition-all h-full top-0", isOpen ? "top-0" : "top-full"]}>
	<div
		class={["h-full rounded-[1.5rem] bg-white p-4", direction === "vertical" ? "w-full" : "w-full lg:max-w-[33rem]"]}
	>
		<div class={["h-full", direction === "vertical" ? " grid grid-rows-2 gap-4" : "grid grid-cols-2 gap-4"]}>
			<!-- Copy -->
			<button
				type="button"
				class="flex flex-col items-center justify-center rounded-lg border border-slate-200/80 bg-white hover:brightness-95 py-6"
				onclick={async (): Promise<void> => {
					if (value) {
						await navigator.clipboard.writeText(value);
						onclose("copy");
					}
				}}
			>
				<Icon icon={copy} class="mb-4 h-10 w-10 text-cmcprimary" />
				<p class="font-semibold text-center leading-snug px-1">
					{copyLabelMap[actionType][tenant.locale]}
				</p>
			</button>

			<!-- Primary actions -->
			<a
				class="flex flex-col items-center justify-center rounded-lg border border-slate-200/80 bg-white hover:brightness-95 py-6"
				href={{ linkedinUrl: value, email: `mailto:${value}`, phone: `tel:${value}` }[actionType]}
				rel="noopener,noreferrer"
				target="_blank"
				onclick={(): void => {
					window.requestAnimationFrame(() => {
						onclose("navigated");
					});
				}}
			>
				<Icon icon={iconMap[actionType]} class="mb-4 h-10 w-10 text-cmcprimary" />
				<p class="font-semibold text-center leading-snug px-1">
					{actionLabelMap[actionType][tenant.locale]}
				</p>
			</a>
		</div>
	</div>
</div>
